/**
 * Password rules for new accounts (owner requirement, 20 October 2026; ADR-010). The same
 * rules should be enforced server-side in Firebase Authentication's password policy; this
 * client check gives immediate, accessible feedback but is not the only control.
 */

export const PASSWORD_RULES = [
  { id: 'length', label: 'At least 8 characters', test: (p: string) => [...p].length >= 8 },
  { id: 'upper', label: 'An uppercase letter (A–Z)', test: (p: string) => /[A-Z]/.test(p) },
  { id: 'lower', label: 'A lowercase letter (a–z)', test: (p: string) => /[a-z]/.test(p) },
  { id: 'number', label: 'A number (0–9)', test: (p: string) => /[0-9]/.test(p) },
  {
    id: 'special',
    label: 'A special character, such as ! ? # or @',
    test: (p: string) => /[^A-Za-z0-9\s]/.test(p),
  },
] as const;

export type PasswordRuleId = (typeof PASSWORD_RULES)[number]['id'];

export function checkPassword(
  password: string,
): { id: PasswordRuleId; label: string; met: boolean }[] {
  return PASSWORD_RULES.map((rule) => ({
    id: rule.id,
    label: rule.label,
    met: rule.test(password),
  }));
}

export function passwordMeetsPolicy(password: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(password));
}
